export const RFQ_INITIATION_FORM_ID = 'rfq-initiation-form';
export const RFQ_INITIATION_FORM_TEST_ID = 'rfq-initiation-form';
